import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Button } from "@ts-digital/vrc";
import { dbxActivate, getCustomersList } from "../../store/actions/customers/index";
import VaporOverlay from "../vapor/overlay";
import Drawer from "../vapor/drawer";
import ClientUsersList from "./clientUsersList.jsx";

import {
  FEATURE_TOGGLE_DATI_SCHEDA_CLIENTE,
  TSDIGITAL_PORTALE_PUBLIC_URL,
  FEATURE_TOGGLE_ACTIVATION_DBX
} from "../../config.js";

import WidgetCard from "../widget/card";
import { Tooltip } from "antd";
import useChangeCompany from "../../customHooks/useChangeCompany";
import { loadCompany } from "../../store/actions/company";
import LoaderSimple from "../general/loader";
import { GetSelectedCompanyStudio } from "../../libs/companiesUtils";

const CustomersCard = props => {
  const {    
    accountantIdSelected,
    companySelected,
    element,
    fromSchedaCliente,
    isCompany,
    isCustomer,
    isAvailableToUser,
    hasAddress,
    isCustomersListView
  } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const main = useSelector(state => state.main);
  const company = useSelector(state => state.company);
  const accountantUuidSelected  = main.accountantUuidSelected;
  const [isActive, setIsActive] = useState(false);
  const [overlay, setOverlay] = useState(false);
  const [openUsersDrawer, setOpenUsersDrawer] = useState(false);

  const studioFind = GetSelectedCompanyStudio();

  const {changeCompanySelected} = useChangeCompany();

  // Connessioni - https://appdev.teamsystemdigital.com/portale/#/{{accountantIdSelected}}/connections/managed
  const link =
    TSDIGITAL_PORTALE_PUBLIC_URL +
    "#/" +
    accountantIdSelected +
    "/connections/managed";

  const activeDbx = () => {
    const args = {
      accountantUuidSelected: accountantUuidSelected,
      clientIdSelected: element && element.id,
      subscribed: element && element.subscribed,
      connected: element && element.connected
    };
    setIsActive(true);
    dispatch(dbxActivate(args)).then(() => {
      setTimeout(() => {
        dispatch(getCustomersList());
      }, 2000);
    });
  };

  const goToSchedaCliente = id => {
    if (companySelected !== id) {
      try {
        let companyFind = company?.companies?.find(x => x.id === id);
        if (companyFind){
          changeCompanySelected(id);
          navigate("/scheda-cliente");
        } else {
          setOverlay(true);
          dispatch(loadCompany(id))
            .then(res => {
              if (res?.items?.[0]?.id) {
                setOverlay(false);
                changeCompanySelected(
                  id, res?.items?.[0], res?.items
                );
                navigate("/scheda-cliente");
              }
            })
            .catch((e) => setOverlay(false));
        }
      } catch (e) {
        console.log("err", e);
      }
    } else {
      navigate("/scheda-cliente");
    }
  };

  const companyName = element && element.details.description;

  const handleOpenUsersDrawer = () => {
    if (window.aptrinsic && fromSchedaCliente) {
      window.aptrinsic("track", "digital-box:SC-UTENTI");
    }
    setOpenUsersDrawer(!openUsersDrawer);
  };

  const handleCloseUsersList = () => {
    setOpenUsersDrawer(!openUsersDrawer);
  };

  const content = <ClientUsersList
    element={element}
    accountantUuidSelected={accountantUuidSelected}
    auth={auth}
    isCustomersListView={isCustomersListView}
  />;

  return (
    <div
      key={"customerListCard_" + element.identifier.taxId}
      className={
        fromSchedaCliente ? "costumerListCard maxWidth" : "costumerListCard"
      }
    >
      <VaporOverlay visible={overlay} ><LoaderSimple message="Caricamento dati in corso..." /></VaporOverlay>
      <WidgetCard
        isCentered={false}
        titleWidget={null}
        type={fromSchedaCliente ? "usersCard" : "box1_3 usersCard"}
      >
        <div style={{ height: "100%", flex: 1 }}>
          <div className={"headerCustomersStyle"}>
            <div className={isCustomer ? "flexHeader" : "flexHeader button"}>
              <div className={"centerdTitle"}>
                <div
                  className={isCustomer ? "iconCircle blue" : "iconCircle grey"}
                >
                  <FontAwesomeIcon
                    icon={isCompany ? ["far", "building"] : ["far", "user"]}
                    className={
                      isCustomer ? "defaultIcon blue" : "defaultIcon grey"
                    }
                  />
                </div>
                <div className="allCustomersTitleBox">
                  {" "}
                  {element.details.description}
                </div>
              </div>
              {!fromSchedaCliente && (
                <div
                  className={
                    isCustomer && FEATURE_TOGGLE_DATI_SCHEDA_CLIENTE !== "true"
                      ? "flexItem "
                      : "flexItem columnDirection"
                  }
                >
                  {isCustomer ? (
                    <React.Fragment>
                      {FEATURE_TOGGLE_DATI_SCHEDA_CLIENTE === "true" && studioFind?.taxRegion !== "ES" &&
                        (isAvailableToUser ? (
                          <Tooltip
                            color={"rgb(0, 80, 117)"}
                            title={
                              <FormattedMessage id="customersWidget.openPage" />
                            }
                          >
                            <FontAwesomeIcon
                              icon={["far", "arrow-right"]}
                              className={"iconArrowRight"}
                              onClick={() =>
                                goToSchedaCliente(isCompany
                                  ? element.identifier.vatNumber
                                  : element.id)
                              }
                            />
                          </Tooltip>
                        ) : (
                          <Tooltip
                            color={"rgb(0, 80, 117)"}
                            title={
                              <FormattedMessage id="customersWidget.noPermissions" />
                            }
                          >
                            <FontAwesomeIcon
                              icon={["far", "arrow-right"]}
                              className={"iconArrowRight disabled"}
                            />
                          </Tooltip>
                        ))}
                      <div className="activeOnDbx">
                        <FormattedMessage id="customersWidget.activeOnDigitalbox" />
                        <div className={"iconOval"} />
                      </div>
                    </React.Fragment>
                  ) : element.subscribed && !element.connected ? (
                    <Button size="small" disabled={true}>
                      <span style={{ fontSize: "12px" }}>
                        <FormattedMessage id="customersWidget.awaitingDbx" />
                      </span>
                    </Button>
                  ) : FEATURE_TOGGLE_ACTIVATION_DBX === "true" ? (
                    isActive ? (
                      <FontAwesomeIcon
                        style={{ color: "rgb(0, 144, 209)" }}
                        icon={["far", "circle-notch"]}
                        spin
                      />
                    ) : (
                      <Tooltip
                        color={"rgb(0, 80, 117)"}
                        placement="top"
                        title={
                          <FormattedMessage id="customersWidget.activeDbxTooltip" />
                        }
                        style={{ zIndex: 9999 }}
                      >
                        <Button size="small" onClick={activeDbx}>
                          <span style={{ fontSize: "12px" }}>
                            <FormattedMessage id="customersWidget.activeDigitalbox" />
                          </span>
                        </Button>
                      </Tooltip>
                    )
                  ) : (
                    <a href={link} target="_blank" rel="noopener noreferrer">
                      <Button size="small">
                        <span style={{ fontSize: "12px" }}>
                          <FormattedMessage id="customersWidget.activeDigitalbox" />
                        </span>
                      </Button>
                    </a>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className={"contentCustomersStyle"}>
            <div>
              <div className="labelUserOrCompany">
                {isCompany ? (
                  <FormattedMessage id="customersWidget.company" />
                ) : (
                  <FormattedMessage id="customersWidget.user" />
                )}
              </div>
              {hasAddress ? (
                <div className={"contentText"}>
                  {element.details.addresses}
                  <FontAwesomeIcon
                    icon={["fas", "map-marker-alt"]}
                    style={{ marginLeft: "5px" }}
                  />
                </div>
              ) : null}
              <div className="contentFlex">
                <div className={"contentText"}>
                  <FormattedMessage id="customersWidget.cf" />
                  <span className="pivaCfStyle">{element.identifier.taxId}</span>
                </div>
                {isCompany ? (
                  <div className={"contentText"}>
                    <FormattedMessage id="customersWidget.piva" />
                    <span className="pivaCfStyle">
                      {element.identifier.vatNumber}
                    </span>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="openClientUsers">
              <span className="openClientUsersCta" onClick={() => handleOpenUsersDrawer()}>
                <FormattedMessage id="dashboard.clientsSection.usersCta" />
              </span>
            </div>
          </div>
        </div>
      </WidgetCard>
      {openUsersDrawer && (
        <Drawer
          onClose={handleCloseUsersList}
          headerTitle={companyName}
          content={content}
          className="customersUsersDrawer"
        />
      )}
    </div>
  );
};

export default CustomersCard;
